import { useMemo } from 'react'

const usePaymentInfoVisibility = (booth_status: string) => {
  const isPaymentInfoVisible = useMemo(() => {
    return ['B0100003', 'B0100004', 'B0100007'].includes(booth_status)
  }, [booth_status])

  return isPaymentInfoVisible
}

export default usePaymentInfoVisibility
